/* src/app/disclaimer/disclaimer.component.css */
.disclaimer p {
  font-size: 12px;
}
/*# sourceMappingURL=disclaimer.component.css.map */
